import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export const SelectedObstacleDetails = ({
  feature
}) => {

  const {t} = useTranslation();

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      paddingX: '1em'
    },
    refContainer: {
      display: 'flex',
      width: '100%'
    },
    refLabel: {
      fontSize: '1.2em'
    },
    imgContainer: {
      display: 'flex',
      width: '100%'
    },
    dateContainer: {
      display: 'flex',
      width: '100%'
    },
    textContainer: {
      display: 'flex',
      width: '100%'
    }
  };

  return (
    <Stack sx={styles.container} direction='column' spacing={2}>
      <Box sx={styles.refContainer}>
        <Typography sx={styles.refLabel}>{`${t('obstacles.obstacles_ref_label')} - ${feature.properties.token}`}</Typography>
      </Box>
      <Box sx={styles.imgContainer}>
        <img 
          src={feature.properties.image} 
          alt={t('obstacles.image_obstacle_alt', {ref: feature.properties.token})}
          width='100%' 
        />
      </Box>
      {feature.properties.category && (
        <Box sx={styles.textContainer}>
          <Typography>{`${t('obstacles.obstacles_category_label')} : ${feature.properties.category}`}</Typography>
        </Box>
      )}
      <Box sx={styles.dateContainer}>
        <Typography>{`${t('obstacles.obstacles_datetime_label')} : ${moment(feature.properties.datetime).format('DD/MM/YYYY, HH:mm')}`}</Typography>
      </Box>
      {feature.properties.comment && (
        <Box sx={styles.textContainer}>
          <Typography>{`${t('obstacles.obstacles_comment_label')} : ${feature.properties.comment}`}</Typography>
        </Box>
      )}
      {feature.properties.explanation && (
        <Box sx={styles.textContainer}>
          <Typography>{feature.properties.explanation}</Typography>
        </Box>
      )}
    </Stack>
  );
};